import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { statuses } from '../constants'

const StatusSelector = ({ onChange, value = [] }) => {
  const { t } = useTranslation()

  const toggleOption = e => {
    onChange(e.target.value)
  }

  return (
    <div>
      <ComboBox
        menuItems={statuses.map(s => ({ label: t(s.label), value: s.value }))}
        value={value || []}
        multiple
        fullWidth
        label={t('Estado transacción')}
        handleChange={toggleOption}
      />
    </div>
  )
}

export default StatusSelector
